import React, { useState, useMemo, useGlobal } from "reactn";
import SupersetDashboard from "../../components/SupersetDashboard/SupersetDashboard";
import { Row } from "reactstrap";
import { normalizeOrganizationValue } from "../../utils/Helpers";

const Graphs = () => {
    const [global] = useGlobal();
    const [selectedDashboard, setSelectedDashboard] = useState(
        window.config.consul.BI_DASHBOARD_IDS[0] || null
    );

    const dashboards = useMemo(() => window.config.consul.BI_DASHBOARD_IDS || []);
    const userRoles = (localStorage.roles || "").split(",").filter(Boolean);
    const userOrganizationIds = [
        ...(global.user && Array.isArray(global.user.organizations)
            ? global.user.organizations
            : []),
    ]
        .map((organization) => {
            if (
                typeof organization === "string" ||
                typeof organization === "number"
            ) {
                return String(organization);
            }

            return (
                organization.name || null
            );
        })
        .filter(Boolean)
        .map((organization) => normalizeOrganizationValue(organization));
    const hasDashboardAccess = (dashboard) => {
        const allowedOrganizations =
            dashboard.organizations ||
            dashboard.organisations ||
            dashboard.organisation ||
            dashboard.organisationIds ||
            dashboard.organizationIds;

        const normalizedAllowedOrganizations = Array.isArray(allowedOrganizations)
            ? allowedOrganizations
            : allowedOrganizations != null
                ? [allowedOrganizations]
                : null;

        const hasRoleAccess =
            !dashboard.roles ||
            dashboard.roles.some((role) => userRoles.includes(role));

        const hasOrganizationAccess =
            normalizedAllowedOrganizations == null ||
            normalizedAllowedOrganizations
                .map((organization) => normalizeOrganizationValue(organization))
                .some((organizationId) =>
                    userOrganizationIds.includes(organizationId)
                );

        const hasEmailAccess =
            !dashboard.excludedEmails ||
            !dashboard.excludedEmails.includes(
                global.user ? global.user.username : null
            );

        return hasRoleAccess && hasOrganizationAccess && hasEmailAccess;
    };

    const buttons = useMemo(() =>
        dashboards.map((dashboard, index) =>
            hasDashboardAccess(dashboard) ? (
                <button
                    key={index}
                    type="button"
                    className={`btn btn-primary btn-report mx-1 ${selectedDashboard.id === dashboard.id ? "active" : ""
                        }`}
                    onClick={() => handleButtonClick(dashboard)}
                >
                    {dashboard.name}
                </button>
            ) : null
        )
    );

    const handleButtonClick = (dashboard) => setSelectedDashboard(dashboard);

    return (
        selectedDashboard && (
            <SupersetDashboard
                key={selectedDashboard.id}
                id={selectedDashboard.id}
                supersetDomain={window.config.consul.BI_SUPERSET_DOMAIN}
                dashboardName={window.config.consul.BI_DASHBOARD_TITLE || "Графики"}
            >
                <Row className="pb-3 pl-3">{buttons}</Row>
            </SupersetDashboard>
        )
    );
};

export default Graphs;
